module.exports = __webpack_public_path__ + "static/media/religare_desktop.7257d7af.svg";